<span class="icon" on:click={() => dispatch('toggle', { field })}>
  <i class="mdi"
     class:has-text-grey-light={sortField != field}
     class:mdi-sort={sortField != field}
     class:mdi-sort-ascending={sortField == field && sortAsc}
     class:mdi-sort-descending={sortField == field && !sortAsc}/>
</span>

<script lang="ts">
  export let sortField: string, sortAsc :boolean, field: string;

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

</script>